import React from "react";
import Banner from "../components/comman/Banner";
import FaqSection from "../components/faq/FaqSection";
const Faq = () => {
    return (
        <div>
            <Banner title="Faq" />
            <FaqSection />
        </div>
    );
}

export default Faq;
